import { use } from 'react'
import Button from '@talkdesk/cobalt-react-button'
import Link from '@talkdesk/cobalt-react-link'
import Input from '@talkdesk/cobalt-react-input'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import Captcha from '../Captcha'
import { LoginContext } from '../../contexts/Login'
import useLogin from '../../hooks/useLogin'
import { useTranslation } from 'react-i18next'
import { RECOVER_PASSWORD } from '../../constants/links'
import { Text } from '@talkdesk/cobalt-react-typography'

export const Login = ({
  ctx,
  siteKey,
  handleErrorChange,
  setIdentityProvidersDisabled,
  email,
  showCaptcha,
  csrf,
}) => {
  const { t } = useTranslation()
  const {
    username,
    password,
    showCaptcha: captchaVisible,
    disableForm,
    loginButtonState,
    isLoginButtonDisabled,
    recaptchaInstanceRef,
    handleUsernameChange,
    handlePasswordChange,
    handleCaptchaResponse,
    handleSubmit,
  } = useLogin({
    ctx,
    email,
    showCaptcha,
    siteKey,
    csrf,
    handleErrorChange,
    setIdentityProvidersDisabled,
  })

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handleSubmit()
      }}
    >
      <Box paddingBottom={4}>
        <Box paddingBottom={1}>
          <Label htmlFor='login-email'>{t('login.email')}</Label>
        </Box>
        <Input
          id='login-email'
          value={username}
          tabIndex={'0'}
          autoFocus
          onChange={handleUsernameChange}
          type='email'
          placeholder={t('login.emailPlaceholder')}
          disabled={disableForm}
        />
      </Box>
      <Box paddingBottom={4}>
        <Flex alignX='space-between' alignY='center' paddingBottom={1}>
          <Label htmlFor='login-password'>{t('login.password')}</Label>
          <Link tabIndex={'1'} href={RECOVER_PASSWORD}>
            <Text inline>{t('login.forgotPassword')}</Text>
          </Link>
        </Flex>
        <Input
          id='login-password'
          tabIndex={'0'}
          value={password}
          onChange={handlePasswordChange}
          type='password'
          placeholder={t('login.passwordPlaceholder')}
          disabled={disableForm}
        />
      </Box>
      {captchaVisible && siteKey !== '' && (
        <div>
          <Captcha
            siteKey={siteKey}
            recaptchaCallback={handleCaptchaResponse}
            recaptchaInstance={(e) => {
              recaptchaInstanceRef.current = e
            }}
          />
        </div>
      )}
      <Box paddingTop={4}>
        <Button
          tabIndex={'0'}
          htmlType='submit'
          state={loginButtonState}
          type='primary'
          shape='full-width'
          disabled={isLoginButtonDisabled}
        >
          {t('login.action')}
        </Button>
      </Box>
    </form>
  )
}

const LoginWithContext = (props) => {
  const ctx = use(LoginContext)
  return <Login ctx={ctx} {...props} />
}
LoginWithContext.displayName = 'Login'

export default LoginWithContext
